<template>
  <div class="contaier" :class="{hideSidebar: isCollapse}">
    <Sidebar class="sidebar-container" :class="{'show': $store.state.toggleNav}" :isCollapse="isCollapse">
      <div
        class="sidebar-togglebtn"
        :class="{collapse: isCollapse}"
        @click="toggleSideBar"
      >
      <el-icon><Back /></el-icon>
    </div>
    </Sidebar>

    <div class="main-container" id="mainContainer">
      <Header v-if="$store.state.window_width > 768"></Header>
      <HeaderMobile v-else></HeaderMobile>

      <!-- 内容区 -->
      <AppMain></AppMain>
    </div>

    <!-- 通知弹窗 -->
    <notice></notice>
  </div>

</template>


<script setup>
import { ref, watch } from "vue";
import Header from "./components/Header.vue";
import HeaderMobile from "./components/HeaderMobile.vue";
import Sidebar from "./components/Sidebar/Index.vue";
import AppMain from "./components/AppMain.vue";
import notice from "./components/notice.vue";
import { useStore } from "vuex";
import Cookies from "js-cookie";

const isCollapse = ref(false);
const store = useStore();

// 1: 蓝(默认) 2：绿 3：灰 4: 紫
watch(()=>store.getters.theme_color,(newVal)=>{
  document.documentElement.classList.forEach(item => {
    if(item.indexOf("theme_") > -1) {
      document.documentElement.classList.remove(item);
    }
  })
  document.documentElement.classList.add(`theme_${newVal}`);
}, {immediate: true})
const toggleSideBar = ()=>{
  
  if(store.state.window_width > 768) {
    isCollapse.value = !isCollapse.value
  }else {
    store.commit('SET_TOGGLENAV', false)
  }
}
</script>